import { c as _c } from "react/compiler-runtime";
import { DateFilterCustomPicker } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-custom-picker";
import { getCustomDateFilterKind } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { Menu, MenuSeparator } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { Fragment, useState } from "react";

/** Width of the dropdown, which fits the date range field. Set on the menu and its paper alike */
const DROPDOWN_WIDTH = "260px";

/** The items to pick a date or a date range to filter by */
const CUSTOM_DATE_ITEMS = [{
  kind: "since",
  label: "From"
}, {
  kind: "range",
  label: "Date range"
}];
/**
 * A chip to filter by a date. It offers fixed periods and lets the user pick a date to filter
 * since, up to today, or a date range. They are kept in the URL as e.g. "since:2026-10-27" and
 * "range:2026-10-01_2026-10-27".
 * Only one of them is applied at a time.
 */
export function DateFilterChip(t0) {
  const $ = _c(49);
  const {
    filteredColumn,
    label,
    presets,
    tableType
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openedPicker, setOpenedPicker] = useState();
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== anchorEl || $[1] !== filteredColumn || $[2] !== getFilterIdsForColumn || $[3] !== label || $[4] !== openedPicker || $[5] !== presets || $[6] !== tableType || $[7] !== updateFilterItem) {
    const activeFilterId = getFilterIdsForColumn(filteredColumn).at(0);
    const activeCustomKind = activeFilterId === undefined ? undefined : getCustomDateFilterKind(activeFilterId);
    const shownPicker = openedPicker ?? activeCustomKind;
    let t12;
    if ($[21] !== filteredColumn || $[22] !== tableType || $[23] !== updateFilterItem) {
      t12 = function toggleFilter(filterId) {
        updateFilterItem({
          tableType,
          filteredColumn,
          filterId,
          shouldReplaceFilterInColumn: true
        });
      };
      $[21] = filteredColumn;
      $[22] = tableType;
      $[23] = updateFilterItem;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    const toggleFilter = t12;
    const applyPickedFilter = function applyPickedFilter(filterId_0) {
      if (filterId_0 !== activeFilterId) {
        toggleFilter(filterId_0);
      }
    };
    let t13;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = function closeDropdown() {
        setAnchorEl(null);
        setOpenedPicker(undefined);
      };
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    const closeDropdown = t13;
    T1 = Box;
    t10 = "div";
    const t14 = !!anchorEl;
    let t15;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = event => setAnchorEl(event.currentTarget);
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    if ($[27] !== filteredColumn || $[28] !== label || $[29] !== t14) {
      t11 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t14} onClick={t15} />;
      $[27] = filteredColumn;
      $[28] = label;
      $[29] = t14;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    T0 = Menu;
    t1 = anchorEl;
    t2 = !!anchorEl;
    t3 = closeDropdown;
    t4 = DROPDOWN_WIDTH;
    t5 = true;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        paper: {
          sx: {
            width: DROPDOWN_WIDTH
          }
        }
      };
      $[31] = t6;
    } else {
      t6 = $[31];
    }
    t7 = Object.values(presets).map(preset => <FilterChipDropdownItem key={preset.id} filterItem={preset} isItemSelected={preset.id === activeFilterId} onItemClicked={filterId_1 => {
      setOpenedPicker(undefined);
      toggleFilter(filterId_1);
    }} shouldShowCheckbox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} />);
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <MenuSeparator />;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    t9 = CUSTOM_DATE_ITEMS.map(t16 => {
      const {
        kind,
        label: itemLabel
      } = t16;
      return <Fragment key={kind}><FilterChipDropdownItem filterItem={{
          id: kind,
          label: itemLabel
        }} isItemSelected={activeCustomKind === kind} onItemClicked={() => {
          if (activeCustomKind === kind && activeFilterId !== undefined) {
            setOpenedPicker(undefined);
            toggleFilter(activeFilterId);
          } else {
            setOpenedPicker(kind);
          }
        }} shouldShowCheckbox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} />{shownPicker === kind && <DateFilterCustomPicker kind={kind} activeFilterId={activeFilterId} onFilterPicked={applyPickedFilter} />}</Fragment>;
    });
    $[0] = anchorEl;
    $[1] = filteredColumn;
    $[2] = getFilterIdsForColumn;
    $[3] = label;
    $[4] = openedPicker;
    $[5] = presets;
    $[6] = tableType;
    $[7] = updateFilterItem;
    $[8] = T0;
    $[9] = T1;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[8];
    T1 = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t12;
  if ($[33] !== T0 || $[34] !== t1 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    t12 = <T0 anchorEl={t1} open={t2} onClose={t3} minWidth={t4} disableEnforceFocus={t5} slotProps={t6}>{t7}{t8}{t9}</T0>;
    $[33] = T0;
    $[34] = t1;
    $[35] = t2;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== T1 || $[45] !== t10 || $[46] !== t11 || $[47] !== t12) {
    t13 = <T1 component={t10}>{t11}{t12}</T1>;
    $[44] = T1;
    $[45] = t10;
    $[46] = t11;
    $[47] = t12;
    $[48] = t13;
  } else {
    t13 = $[48];
  }
  return t13;
}